import React from 'react';
import ServerCard from './ServerCard';

interface RelatedServer {
  id: string | number;
  title: string;
  description: string;
  launchDate: string;
  rating: number;
  status: 'online' | 'offline' | 'maintenance' | 'starting';
}

interface RelatedServersProps {
  servers: RelatedServer[];
  className?: string;
}

const RelatedServers: React.FC<RelatedServersProps> = ({ 
  servers,
  className = ''
}) => {
  if (!servers || servers.length === 0) {
    return null;
  }

  return (
    <div className={`bg-gray-800 rounded-lg shadow-lg p-6 ${className}`}>
      <h3 className="text-xl font-bold mb-4">Related Servers</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {servers.map(server => (
          <ServerCard
            key={server.id}
            id={server.id.toString()}
            name={server.title}
            description={server.description}
            createdAt={server.launchDate}
            rating={server.rating}
            status={server.status}
          />
        ))}
      </div>
    </div>
  );
};

export default RelatedServers;